export const white = "#ffffff";
export const black = "#000000";

export const red1 = "#FF3B3B";
export const red2 = "#FF6060";
export const green1 = "#09b790";
export const green2 = "#08DCAD";
export const darkGreen1 = "#1C5856";
export const amber1 = "#F5A623";

export const darkBlue1 = "#141d2e";
export const darkBlue2 = "#252e3d";

export const midBlue = "#688AAD";

export const lightBlue1 = "#A2AFCA";

export const lightGrey1 = "#E8E8E8";
export const veryLightGrey = "#f2f2f2";

export const yellow = "#E1E748";
export const mustardYellow = "#F6D86C";

export const purple1 = "#9168CC";
export const purple2 = "#98ACFF";

export const hotPink = "#FF5982";

// kaizen colors
export const pageBackground = "#F3F6FA";
export const darkGrey = "#3A3A3A";
export const darkBlue = "#032C51";
export const brightBlue = "#2189FF";
export const mediumBlue = "#42617D";
export const cyan = "#35DDD7";
